import { gql } from "graphql.macro";
const queryApiErrorAll = gql`
  query queryApiErrorList($itemPath: String = "/sitecore/content/lynkco-global-portal/Content/api-errors", $language: String = "en") {
    obj: item(path: $itemPath, language: $language) {
      list: children {
        ...apiError
      }
    }
  }
  fragment apiError on ApiError {
    code {
      value
    }
    headingType {
      fields: targetItem {
        phrase: field(name: "phrase") {
          value
        }
      }
    }
    headingBody {
      value
    }
    body {
      value
    }
    link {
      href: url
      target
    }
    ctaName {
      value
    }
    ctaType {
      fields: targetItem {
        phrase: field(name: "phrase") {
          value
        }
      }
    }
    colorScheme {
      fields: targetItem {
        key: field(name: "key") {
          value
        }
        phrase: field(name: "phrase") {
          value
        }
      }
    }
    iconName {
      alt
    }
  }
`;
export default queryApiErrorAll;
